import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import HashRedirect from "./Components/HashRedirect/HashRedirect";
import Hamburger from "./Components/Hamburger/Hamburger";
import MobileNav from "./Components/MobileNav/MobileNav";
import SkipLink from "./Components/ui/SkipLink";
import Home from "./Pages/Home/Home";

const App = () => {
  const reduceMotion = useReducedMotion();

  return (
    <BrowserRouter>
      <SkipLink />
      <Hamburger />
      <motion.div
        initial={reduceMotion ? false : { opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: reduceMotion ? 0 : 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<HashRedirect section="projects" />} />
          <Route path="/contact" element={<HashRedirect section="contact" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </motion.div>
      <MobileNav />
    </BrowserRouter>
  );
};

export default App;